import { render, staticRenderFns } from "./SwitchAsync.vue?vue&type=template&id=bff2e31a"
import script from "./SwitchAsync.vue?vue&type=script&lang=js"
export * from "./SwitchAsync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports